import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import NadaConsta from "../../../components/nadaConsta";
import { Card } from "primereact/card";
import { PanelHeaderTemplateOptions } from "primereact/panel";

export default function Acoes({
  acoes
}: {
  acoes: any
}) {
  const { t } = useTranslation();
  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {acoes && acoes.length > 0 ? (<span style={{ color: '#C70039', fontSize: '1.5rem' }} className="pi pi-exclamation-triangle"><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color: 'black' }}>{t('acoesQuod')}</span></span>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color: 'black' }}>{t('acoesQuod')}</span>)} </div>;
  }
  return (
    <Panel headerTemplate={headerTemplate}>
      {!acoes || acoes.length === 0 ? (<NadaConsta />) : (
        <div>
          <div className="flex-consulta  flex-wrap gap-3">
            {acoes[0].resumos.map((item: any, index: number) => (

              <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }} key={index}>
                <div className="flex-consulta  justify-content-between gap-5">
                  <div className="flex-consulta  flex-column gap-1">
                    <span style={{ color: 'white' }} className=" text-sm">{item.label}</span>
                    <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
                  </div>
                  <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                    <i className={item.icon} />
                  </span>
                </div>
              </Card>

            ))}
          </div>
          <br></br>
          <DataTable size="small" value={acoes} tableStyle={{ minWidth: '50rem' }}>
            <Column field="numero" header={t('numero')}></Column>
            <Column field="autor" header={t('autor')}></Column>
            <Column field="comarca" header={t('comarca')}></Column>
            <Column field="forum" header={t('forum')}></Column>
            <Column field="vara" header={t('vara')}></Column>
            <Column field="cidadeUF" header={t('cidadeUF')}></Column>
            <Column field="valor" header={t('valor')}></Column>
            <Column field="dataDistribuicao" header={t('dataDistribuicao')}></Column>
            <Column field="tipo" header={t('tipo')}></Column>
            <Column field="origem" header={t('origem')}></Column>
          </DataTable>
        </div>
      )}
    </Panel>
  )
}